export default {"src":"/_next/static/media/pariveda-logo.5476e323.svg","height":31,"width":218,"blurWidth":0,"blurHeight":0};